import { Alert, Button, createStyles, Stack, Text } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as NoCloudIcon } from '@portals/icons/linear/no-cloud.svg';

interface C2cConnectorErrorEventProps {
  connectorId?: string;
}

export function C2cConnectorErrorEvent({
  connectorId,
}: C2cConnectorErrorEventProps) {
  const { classes, theme } = useStyles();
  const navigate = useNavigate();

  if (!connectorId) {
    return null;
  }

  return (
    <Alert
      title={
        <Text color="gray.9" size="md" weight={600}>
          Cloud-to-Cloud Connector Issue
        </Text>
      }
      icon={<NoCloudIcon color={theme.colors.red['4']} />}
      color="red"
      p="xl"
      radius="lg"
    >
      <Stack>
        <Text color="gray.8">
          There’s an issue with the cloud-to-cloud connector, preventing device
          data from syncing.
        </Text>

        <Button
          w="max-content"
          onClick={() => navigate(`/settings/c2c_connectors/${connectorId}`)}
          className={classes.navigationButton}
        >
          Go to Connector Settings
        </Button>
      </Stack>
    </Alert>
  );
}

const useStyles = createStyles({
  navigationButton: {
    alignSelf: 'end',
  },
});
